import React from 'react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
const chips = ['6 Volumes', '52 weekly sessions', '5 Bonuses', 'By level', '45 · 60 · 90–120 min', 'Print-ready'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print one sheet, run practice'];
const skills = [{
  name: 'Serve',
  color: 'bg-coral'
}, {
  name: 'Pass',
  color: 'bg-indigo'
}, {
  name: 'Set',
  color: 'bg-teal'
}, {
  name: 'Attack',
  color: 'bg-amber'
}];
export function Hero() {
  return <section className="gym-floor relative w-full overflow-hidden text-white" data-id="element-123" data-mp="xbpc32nfnudg">
      <div className="lane-lines pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-124" data-mp="sai535t46z7u" />
      <div className="relative mx-auto w-full max-w-6xl px-4 pb-12 pt-6 sm:px-5 sm:pb-16 lg:pb-20 lg:pt-12" data-id="element-125" data-mp="ncq31iyr9wpx">
        <div className="grid gap-7 lg:grid-cols-[1.05fr_.95fr] lg:items-center lg:gap-x-14 lg:gap-y-6" data-id="element-126" data-mp="3d1sakxd0hjt4">
          <div className="lg:col-start-1 lg:row-start-1" data-id="element-127" data-mp="381e25e7i07uk">
            <p className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1 text-[10px] font-semibold uppercase tracking-[1.6px] text-ink sm:text-[11px]" data-id="element-128" data-mp="3j8ixl0k6uiv8">
              <span className="h-2 w-2 rounded-full bg-coral" aria-hidden="true" data-id="element-129" data-mp="3o6u7fbahgtdg" />
              52 Weeks of Volleyball Practice Plans · for coaches
            </p>
            <h1 className="mt-4 font-display text-[40px] font-extrabold leading-[1.02] tracking-tight text-white sm:text-6xl lg:text-[64px] xl:text-[70px]" data-id="element-130" data-mp="3e8mt707kwpf5">
              Walk into every practice{' '}
              <span className="mark-hl-dark" data-id="element-131" data-mp="359t19n570n7x">already planned.</span>
            </h1>
          </div>

          <div className="lg:col-start-1 lg:row-start-2" data-id="element-132" data-mp="2qkwjuzh8xxun">
            <p className="max-w-xl text-[15px] leading-relaxed text-white/80 sm:text-base lg:text-lg" data-id="element-133" data-mp="2viy1dfz0xp40">
              A full year of done-for-you volleyball practices: 52 weekly
              sessions across serving, passing, setting, hitting, blocking and
              defense — each one timed, drilled and ready to run. No more
              planning the night before. No more players standing in lines.
            </p>

            <div className="mt-6 w-full max-w-md lg:mx-0" data-id="element-134" data-mp="nat6j94y4gjn">
              <CtaButton data-id="element-135" data-mp="n98djnya55nw">Get the 52-Week Practice Plans</CtaButton>
            </div>
          </div>

          <div className="lg:col-start-2 lg:row-span-4 lg:row-start-1 lg:self-center" data-id="element-136" data-mp="ia5kl1vkqpwa">
            <ProductVisual className="w-full max-w-[640px] lg:max-w-none" data-id="element-137" data-mp="deyk02xlq1bl" />
          </div>

          <div className="lg:col-start-1 lg:row-start-3" data-id="element-138" data-mp="1b0duk6fyi3zs">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-139" data-mp="161auz1iqwpz7">
              <ul className="flex gap-1.5" aria-label="Every session covers the core skills" data-id="element-140" data-mp="112g7vndqwf9a">
                {skills.map(s => <li key={s.name} className={`rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider ${s.color} ${s.name === 'Attack' ? 'text-ink' : 'text-white'}`} data-id="element-141" data-mp="x0cq6h0hgefk">
                    {s.name}
                  </li>)}
              </ul>
              <p className="max-w-sm text-xs leading-relaxed text-white/70" data-id="element-142" data-mp="21aefn7vxa56e">
                Built for <span className="font-semibold text-white" data-id="element-143" data-mp="26a96xcjm0wrz">coaches running club, school &amp; rec teams</span>{' '}
                with mixed skill levels
              </p>
            </div>

            <ul className="mt-5 grid gap-2 text-xs text-white/65 sm:flex sm:flex-wrap sm:gap-x-5" data-id="element-144" data-mp="2fzsqylj26wof">
              {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-145" data-mp="2kxu8h20u6nxs">
                  <span className="h-1.5 w-1.5 flex-none rounded-full bg-amber" data-id="element-146" data-mp="2p0qqaqijyg0o" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="lg:col-start-1 lg:row-start-4" data-id="element-147" data-mp="2tx7m86vztyob">
            <ul className="flex flex-wrap gap-1.5 sm:gap-2" data-id="element-148" data-mp="unrc91ttltvi">
              {chips.map(chip => <li key={chip} className="rounded-full border border-white/20 bg-ink-deep/50 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-white/75 sm:px-3 sm:py-1.5 sm:text-[11px]" data-id="element-149" data-mp="zmc4adyx578v">
                  {chip}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
      <div className="apparatus-strip h-1.5 w-full" aria-hidden="true" data-id="element-150" data-mp="9a7c9dt1marf" />
    </section>;
}